function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffad10"
    },
    d: "M10,1a9,9,0,1,0,9,9,9,9,0,0,0-9-9Zm0,16.364A7.364,7.364,0,1,1,17.364,10,7.364,7.364,0,0,1,10,17.364Z",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffad10"
    },
    d: "M12,9c-.552,0-1,.327-1,.73v5.107c0,.4.448.73,1,.73s1-.327,1-.73V9.73C13,9.327,12.552,9,12,9Z",
    transform: "translate(-3 -1.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffad10"
    },
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(8 4)"
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.8247e8897079c55946fb3b2929a75f32.svg";